import { businessKey } from 'queryKeys';

export const CONCEPTS = 'concepts';

const PERFORMANCE = 'performance';
const PROMO_CODES = 'promo-codes';
const ORIGINAL = 'original';

const MUTATION_ARCHIVE = 'archive';
const MUTATION_ACTIVATE = 'activate';
const MUTATION_MOVE_TO_PREVIEW = 'moveToPreview';
const MUTATION_UNARCHIVE = 'unarchive';
const MUTATION_INACTIVATE = 'inactivate';
const MUTATION_ADD_TO_CONCEPT_FAMILY = 'addToConceptFamily';
const MUTATION_SHARE = 'share';
const MUTATION_UNSHARE = 'unshare';
const MUTATION_MARK_AS_READ = 'markAsRead';
const MUTATION_ACTIONS_LOG = 'actionsLog';
const MUTATION_ATTACHMENTS = 'attachments';
const MUTATION_TRANSCRIPTIONS = 'transcriptions';
const MUTATION_EDIT = 'edit';
const MUTATION_EXPORT = 'export';

export const cptQuery = businessKey.query(CONCEPTS);

export const details = cptQuery.details();
export const model = cptQuery.exact();

export const grids = cptQuery.grids();
export const grid = cptQuery.grid();

export const original = cptQuery.exact(CONCEPTS, ORIGINAL);
export const performance = cptQuery.exact(CONCEPTS, PERFORMANCE);
export const promoCodes = cptQuery.exact(CONCEPTS, PROMO_CODES);
export const actionsLog = cptQuery.exact(CONCEPTS, MUTATION_ACTIONS_LOG);
export const attachments = cptQuery.exact(CONCEPTS, MUTATION_ATTACHMENTS);
export const transcriptions = cptQuery.exact(CONCEPTS, MUTATION_TRANSCRIPTIONS);

export const mutations = cptQuery.mutations();
export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();

export const archive = mutations.mutate(MUTATION_ARCHIVE);
export const activate = mutations.mutate(MUTATION_ACTIVATE);
export const moveToPreview = mutations.mutate(MUTATION_MOVE_TO_PREVIEW);
export const unarchive = mutations.mutate(MUTATION_UNARCHIVE);
export const inactivate = mutations.mutate(MUTATION_INACTIVATE);
export const addToConceptFamily = mutations.mutate(
  MUTATION_ADD_TO_CONCEPT_FAMILY
);
export const share = mutations.mutate(MUTATION_SHARE);
export const unshare = mutations.mutate(MUTATION_UNSHARE);
export const markAsRead = mutations.mutate(MUTATION_MARK_AS_READ);
export const edit = mutations.mutate(MUTATION_EDIT);

export const exportConcepts = mutations.mutate(MUTATION_EXPORT);
